import { useNavigate } from "react-router-dom";
import { MessageSquareText, ChevronRight, Send } from "lucide-react";
import P2PInbox from "@/components/chat/P2PInbox";

function HubButton({ Icon, title, subtitle, onClick, testid, accent }) {
  return (
    <button onClick={onClick} data-testid={testid}
      className={[
        "w-full flex items-center gap-4 rounded-2xl border-4 px-4 py-4 text-left transition-transform duration-150 active:translate-x-[3px] active:translate-y-[3px] active:shadow-none",
        accent ? "bg-charcoal border-gold shadow-[5px_5px_0px_#D4AF37]" : "bg-white border-charcoal shadow-hard",
      ].join(" ")}>
      <span className={["w-12 h-12 rounded-xl border-2 grid place-items-center shrink-0", accent ? "bg-white/10 border-gold" : "bg-gold border-charcoal"].join(" ")}>
        <Icon size={22} strokeWidth={2.2} className={accent ? "text-gold" : "text-charcoal"} />
      </span>
      <div className="min-w-0 flex-1">
        <p className={["font-serif text-xl leading-tight", accent ? "text-white" : "text-charcoal"].join(" ")}>{title}</p>
        <p className={["font-mono text-[10px] uppercase tracking-[0.14em]", accent ? "text-white/50" : "text-charcoal/50"].join(" ")}>{subtitle}</p>
      </div>
      <ChevronRight size={18} className={accent ? "text-gold" : "text-charcoal/40"} />
    </button>
  );
}

export default function ChatHub() {
  const navigate = useNavigate();

  return (
    <div className="h-full w-full flex flex-col bg-cream" data-testid="chat-hub">
      <header className="shrink-0 px-4 pt-5 pb-3">
        <p className="font-mono text-[10px] uppercase tracking-[0.28em] text-gold">Communication Matrix</p>
        <h1 className="font-serif text-3xl text-charcoal leading-none">Chat</h1>
      </header>
      <div className="flex-1 min-h-0 overflow-hidden relative">
        {/* Website keeps ONLY private 1:1 chats. Group + Team chat now live in
            the standalone Misteck Messenger PWA (install for your friend group). */}
        <P2PInbox embedded onBack={() => {}} />
      </div>
      <div className="shrink-0 px-4 pb-5 pt-1">
        <HubButton Icon={Send} title="Open Messenger" subtitle="Group + team chat · install the app"
          onClick={() => { window.location.href = "/messenger"; }} testid="chat-open-messenger" accent />
      </div>
    </div>
  );
}
